import { Injectable } from '@angular/core';
import { skipWhile, take } from 'rxjs';
import { selectMeState } from '../store/core.selectors';
import { Store } from '@ngrx/store';
import { UsersService } from '@app/services/users/users.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LimitAccessService {
  
  private arraySettingAccessSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private tierIDSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public arraySettingAccess$ = this.arraySettingAccessSubject.asObservable();
  public tierID$ = this.tierIDSubject.asObservable();
  public arraySettingAccess: any;
  public settingAccessLimiter: any;
  public tierID: any;

  constructor(
    public _users: UsersService,
    public store$: Store
  ) {
    this.store$.select(selectMeState).pipe(
      skipWhile(res => res == null),
      take(2)
    ).subscribe((me) => {
      this.settingAccessLimiter = me.settingAccessLimiter;
      const objSettingAccess = this.settingAccessLimiter;
      this.arraySettingAccess = Object.entries(objSettingAccess);
      this.arraySettingAccessSubject.next(this.arraySettingAccess);

      this.tierID = me.tier_id;
      const varTierID = this.tierID;
      this.tierIDSubject.next(varTierID);
    });    
  }


  getTierId(){
    return this.tierID;
  }

  getAccess(firstLevel: any, secondLevel: any, thirdLevel: any, fourthLevel: any): boolean {

    if(firstLevel.trim() == ""){
      return false;
    }

    if (this.arraySettingAccess && typeof this.arraySettingAccess === 'object' && firstLevel !="") {
      let arraySettings = Object.entries(this.arraySettingAccess)

      let accessFirst = false;
      let accessSecond = false;
      let accessThird = false;
      let accessFourth = false;

      for (let i = 0; i < arraySettings.length; i++) {

        if (arraySettings[i][1][0] === firstLevel) {
          accessFirst = true;

          if(secondLevel.trim() == ""){
            if (arraySettings[i][1][1].hasOwnProperty("access")){
              return arraySettings[i][1][1]['access'];
            }else{
              return false;
            }
          }
        }

        if(accessFirst){
          if (arraySettings[i][1][1].hasOwnProperty(secondLevel)){
            accessSecond = true;

            if(thirdLevel.trim() == ""){
              if (arraySettings[i][1][1][secondLevel].hasOwnProperty("access")){
                return arraySettings[i][1][1][secondLevel]['access'];
              }else{
                return false;
              }
            }
          }
        }

        if(accessSecond){
          if (arraySettings[i][1][1][secondLevel]['options'].hasOwnProperty(thirdLevel)){
            accessThird=true;

            if(fourthLevel.trim() == ""){
              if (arraySettings[i][1][1][secondLevel]['options'][thirdLevel] === true || 
                  arraySettings[i][1][1][secondLevel]['options'][thirdLevel] === false){
                return arraySettings[i][1][1][secondLevel]['options'][thirdLevel];
              }else{
                return false;
              }
            }
          }
        }

        if(accessThird){
          if (arraySettings[i][1][1][secondLevel]['options'][thirdLevel].hasOwnProperty(fourthLevel)){
            accessFourth=true;
            return arraySettings[i][1][1][secondLevel]['options'][thirdLevel][fourthLevel];
          }
        }
      } 
    } 
    return null;
  }

}